import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { CommonService } from './common.service';

import { Setting, SettingSearchingCriteria } from '@models/setting';
import { Locale } from '@app/types/locale';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PageResponse } from '@app/models/page-response';

@Injectable()
export class SettingService {

  constructor(
    private httpClient: HttpClient,
    private commonService: CommonService
  ) { }

  getAll(): Observable<Setting> {
    return this.httpClient.get(`${environment.API_END_POINT}/settings`, { headers: this.commonService.getHeaders() })
      .pipe(
        map(response => <Setting>(<any>response).content),
        catchError((error: Response | any) => this.commonService.handleHttpError(error))
      );
  }


  update(setting: Setting): Observable<Setting> {

    let body = JSON.stringify(setting);

    return this.httpClient.put(`${environment.API_END_POINT}/settings`, body, { headers: this.commonService.getHeaders() })
      .pipe(
        map(response => <Setting>(<any>response).content),
        catchError((error: Response | any) => this.commonService.handleHttpError(error))
      );

  }
  
  globalSearch(globalCriteria: string = '', criteria: SettingSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<Setting>> {

    let params: HttpParams = new HttpParams();
    params = params.set('global', globalCriteria);
    params = params.set('criteria', JSON.stringify(criteria == null ? new SettingSearchingCriteria() : criteria));
    params = params.set('page', page.toString());
    params = params.set('size', size.toString());
    if (sortField != null) {
        params = params.set('sort', sortField + ',' + sortDirection);
    }

    return this.httpClient.get(`${environment.API_END_POINT}/settings`, { headers: this.commonService.getHeaders(), params: params })
        .pipe(
            map(response => {
                let tempObj = <Setting[]>(<any>response);
                return tempObj;
            }),
            catchError((error: Response | any) => this.commonService.handleHttpError(error))
        );
} 

}
